import { IField } from "../types";

export class StyleUtils {
  public static getWidth(item: IField): string {
    switch (true) {
      case item.label && item.length !== undefined:
        const label = item.label;
        if (label && label.length > item.length) {
          return String(Math.min(label.length * 15, 1000));
        } else {
          return String(Math.min(Number(String(item.length)) * 15, 1000));
          // return String(Math.min((Number(String(item.length)) + 5) * 20, 1000));
          // return String(Math.min(item.length * 20, 1000));
        }

      case item.label === undefined && item.length !== undefined:
        return String(Math.min((Number(String(item.length)) + 5) * 15, 2000));

      case item.label !== undefined && item.length === undefined:
        const labelLength = label && label.length ? label.length : item.length;
        return String(Math.min(labelLength * 15));

      default:
        return "";
    }
  }
}
